import React from 'react';
import './InstallPromptBanner.css';

function InstallPromptBanner({ onInstall, onDismiss }) {
  return (
    <div className="install-banner">
      <div className="install-banner-content">
        <span className="install-banner-text">Install Click Mania for quick access</span>
        <div className="install-banner-buttons">
          <button 
            className="install-banner-btn install-btn-primary"
            onClick={onInstall}
          >
            Install
          </button>
          <button 
            className="install-banner-btn install-btn-secondary"
            onClick={onDismiss}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstallPromptBanner;